import { JSX } from "react";

export function NoPage(): JSX.Element {
    return <h1>404</h1>;
}

NoPage.displayName = "NoPage";
